import { render, staticRenderFns } from "./props-table.vue?vue&type=template&id=f1ef6d9a&scoped=true&lang=html"
import script from "./props-table.vue?vue&type=script&lang=js"
export * from "./props-table.vue?vue&type=script&lang=js"
import style0 from "./props-table.vue?vue&type=style&index=0&id=f1ef6d9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ef6d9a",
  null
  
)

/* custom blocks */
import block0 from "./props-table.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports